import React, { useEffect, useState } from 'react'
import { ChannelModel } from '../../models/channels/channels.model';
import { appNote } from '../shared/constants'
import { AddDarkIcon } from '../../icon';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { Button } from '@mui/material';
import { ChannelUserModel } from '../../models/users.model';
import { ChannelUserService } from '../../services/ChannelUserService';
import { ProviderService } from '../../services/channels/ChannelProviderService';
interface IProps extends ChannelModel {
    openNewChannel?: () => void;
    ActiveChannel: boolean;
}

const ProviderCardComponent = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const User: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage()

    const [disable, setDisable] = useState<boolean>(false)

    const handleEarlyAcess = (channelType: number) => {
        ProviderService.ApplyForEarlyAcess({
            name: User.FullName,
            email: User.Email,
            admin_id: User.ID,
            channel_type: channelType,
            organization_id: User.OrganizationID,
            organization_name: User.OrganizationName
        }).then(res => {
            setDisable(true)
        }).catch(() => {
        })
    }

    useEffect(() => {
        if (User.Channel_Wishlist.includes(3)) {
            setDisable(true)
        }
    }, [])

    return (
        <div className={`m-2 mx-auto   ${IsMobileDevice ? "card-body-mobile" : "card-body"} add-channel-card  d-flex flex-direction`} onClick={props.ActiveChannel ? props.openNewChannel : () => { }}>
            <div className='h-p-15'>
                {(!props.ActiveChannel || props.Label === "Whatsapp") &&
                    <div className={`h-4 w-p-60 mx-auto mb-auto ${props.Label === "Whatsapp" ? "bg-color-add-channel-card-experimental color-add-channel-card-experimental-header" : "bg-color-channel-dashboard-closed-tickets color-primary-success"} add-channel-card-tag d-flex justify-center align-center h5-medium`}>
                        {props.Label === "Whatsapp" ? "Experimental Feature..." : props.Label === "Facebook + Instagram" ? "Available Soon..." : ""}
                    </div>
                }
            </div>
            <div className=' d-flex align-center justify-center h-p-20'> {props.Icon}</div>
            <div className={`d-flex flex-direction mx-2 align-center justify-around h-p-40`}>
                <div className='h2-semibold color-channel-name-font t-align-center my-auto h-p-30'>
                    {props.Label}
                </div>
                <div className='h5-medium color-channel-text-font t-align-center my-auto h-p-70 px-2'>
                    {props.Text}
                </div>
            </div>
            {props.ActiveChannel ?
                <div onClick={props.openNewChannel} className={`d-flex align-center justify-center t-align-center ${IsMobileDevice ? "" : ""} h-p-20`}>
                    <AddDarkIcon />
                    <div className='pl-1 h3-medium'>{appNote.ADD_CHANNEL}</div>
                </div> :
                <div className='d-flex justify-center align-center flex-direction h-p-20'>
                    <Button className={`h-5 h3-medium px-5 align-center justify-center bg-color-primary-light color-secondary`} disabled={disable} style={{ textTransform: 'none' }} onClick={() => { handleEarlyAcess(3) }}>{disable ? "Applied!!" : "Apply"}</Button>
                    {/* <div className='h5-medium color-primary-warning'> Apply for early access!!!</div> */}
                </div>
            }
        </div>
    );

}



export default ProviderCardComponent;